<div class="flex flex-col sandbox-card" [ngClass]="{'cursor-pointer': !loader}" (click)="!loader ? goToEndpoints(): ''">
  <div class="flex flex-row mb-24">
    <img src="/assets/images/sandbox.svg" class="w-50 h-30 mr-20">
    <div class="mat-headline-5 fw-bold description word-break-word mb-0">
      {{sandbox?.service?.name ? sandbox?.service?.name : sandboxCardInfo?.name }}
    </div>
  </div>
  <mat-divider class="mb-16"></mat-divider>
  <div *ngIf="!loader; else skeletonLoader" class="flex flex-row mb-16">
    <ng-container *ngIf="DeployStatus.DEPLOYED === sandbox?.instance?.status && trialStatus.includes('expired'); else isNotExpired">
      <div *ngIf="sandbox?.instance?.status" class="warn-solid-bg traffic-light icon-container mr-16">
        <mat-icon svgIcon="error_outline" class="flex items-center white-fg icon icon-sm"></mat-icon>
      </div>
      <div class="mat-subtitle-2 fw-600">
        {{'SANDBOX.EXPIRED' | transloco}}
      </div>
    </ng-container>
    <ng-template #isNotExpired>
      <div *ngIf="sandbox?.instance?.status" [ngClass]="statusInfo[sandbox?.instance?.status]?.colorClass" class="traffic-light icon-container mr-16">
        <mat-icon svgIcon="{{statusInfo[sandbox?.instance?.status]?.icon}}" class="flex items-center white-fg icon icon-sm"></mat-icon>
      </div>
      <div class="mat-subtitle-2 fw-600 mb-0 word-break-word">
        {{(sandbox?.instance?.status ? 'INSTANCE_STATUS.' + sandbox?.instance?.status : 'INSTANCE_STATUS.NA') | transloco}}
      </div>
    </ng-template>
  </div>

  <div *ngIf="(DeployStatus.DEPLOYING === sandbox?.instance?.status) || (DeployStatus.UPDATING === sandbox?.instance?.status)" class="flex flex-col">
    <div class="flex flex-row justify-between mb-26">
      <span class="mat-body-2 word-break-word">
        {{'SANDBOX.CARD.SANDBOX_SETUP' | transloco}}
      </span>
    </div>
  </div>
  <div *ngIf="!loader; else skeletonLoader"
       class="flex flex-col justify-between">
    <div *ngIf="(DeployStatus.DEPLOYED === sandbox?.instance?.status) || (DeployStatus.UPDATED === sandbox?.instance?.status)" class="flex flex-row justify-between w-100-percent mb-26">
      <span class="mat-body-2 word-break-word"
            [ngClass]="{'warn-solid-fg' : trialStatus.includes('expired')}">
        {{trialStatus}}
      </span>
    </div>
    <div *ngIf="sandbox?.instance?.region" class="flex flex-row mb-8">
      <mat-icon svgIcon="place" class="icon-sm mr-12"></mat-icon>
      <span class="mat-small fw-700 m-0 mt-0">{{
        (sandbox?.instance?.region) | uppercase}}</span><br>
    </div>
    <div *ngIf="releaseVersion" class="flex flex-row">
      <mat-icon svgIcon="token" class="icon-sm mr-12"></mat-icon>
      <span class="mat-small fw-700 m-0 mt-0 mr-10">{{('BLUEPRINT_SUMMARY.RELEASE' | transloco ) + ' ' +
        (releaseVersion ? releaseVersion : 'N/A') }}</span>
        <div *ngIf="isAMR" class="flex flex-row justify-center items-center amr-text pl-10">
          {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
        </div><br>
    </div>
  </div>
  <div *ngIf="!loader; else skeletonLoader" class="flex flex-col">
    <div *ngIf="DeployStatus.TERMINATING === sandbox?.instance?.status" class="flex flex-row justify-between mb-50">
      <span class="mat-body-2 word-break-word">{{'SANDBOX.CARD.SANDBOX_TERMINATING' | transloco}}</span>
    </div>
  </div>
  <div *ngIf="!loader; else skeletonLoader" class="flex flex-col">
    <div *ngIf="[DeployStatus.FAILED, DeployStatus.TERMINATION_FAILED, DeployStatus.UPDATE_FAILED].includes(sandbox?.instance?.status)" class="flex flex-row justify-between mb-50">
      <span class="mat-body-2 word-break-word">
        {{( DeployStatus.FAILED === sandbox?.instance?.status ? 'SANDBOX.CARD.SANDBOX_SETUP_FAILED' :
        DeployStatus.UPDATE_FAILED === sandbox?.instance?.status ? 'SANDBOX.CARD.SANDBOX_UPDATE_FAILED' :
          'SANDBOX.CARD.SANDBOX_TERMINATION_FAILED') | transloco}}
      </span>
    </div>
  </div>
  <ng-template #skeletonLoader>
    <div class="pl-6 skeleton-loader">
      <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
    </div>
  </ng-template>
</div>
